import { Pipe, PipeTransform } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { DateTime } from 'luxon';

@Pipe({
  name: 'groupItemMessageTime',
  standalone: true,
})
export class GroupItemMessageTimePipe implements PipeTransform {
  transform(createdDateTimeUTC: Date | string, activeLang: string): string {
    if (!createdDateTimeUTC) {
      return '';
    }

    const now = DateTime.local();
    const messageTime = DateTime.fromISO(String(createdDateTimeUTC), {
      zone: DateTime.local().zoneName as string,
    });
    const duration = now.diff(messageTime);

    const durationMappings = [
      { unit: 'days', threshold: 7, text: 'days' },
      { unit: 'hours', threshold: 24, text: 'hours' },
      { unit: 'minutes', threshold: 60, text: 'minutes' },
    ];

    for (const mapping of durationMappings) {
      const value = Math.floor(duration.as(mapping.unit as any));
      if (value >= 1 && value <= mapping.threshold) {
        return `${value} ${translate(mapping.text)} ${translate('ago')}`;
      }
    }

    if (duration.as('days') > 7) {
      // DATE_MED is Intl-backed (short month, locale-ordered) — en: "May 11, 2026",
      // sv: "11 maj 2026" — rather than month-first from a literal 'MMM dd, yyyy'.
      return messageTime.setLocale(activeLang).toLocaleString(DateTime.DATE_MED);
    }

    return translate('a moment ago');
  }
}
